import {
  DetailsWrapper,
  Wrapper,
} from '@/property-details/components/property-details-content-styles';
import { Placeholder } from 'rsuite';
import styled from 'styled-components';
import { SkeletonBlock, SkeletonTitle } from './generic-skeleton-placeholders';

const Flex = styled(DetailsWrapper)`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ListHeaderSkeleton = styled(SkeletonBlock)`
  width: 100px;
  height: 17px;
  margin-bottom: 15px;
  padding-bottom: 5px;
  border-bottom: 1px solid black;
`;

const ComplaintItemSkeleton = () => (
  <Placeholder.Paragraph rows={2} style={{ marginBottom: '15px' }} active />
);

/**
 * Skeleton placeholder for the SummarizedComplaints component.
 * Mimics the structure of SummarizedComplaints during loading states.
 */
export function SummarizedComplaintsSkeleton() {
  return (
    <Wrapper>
      <Flex>
        {/* Skeleton for StreetAddress */}
        <SkeletonTitle width="40%" style={{ marginBottom: '10px' }} />
        {/* Skeleton for ListHeader */}
        <ListHeaderSkeleton />
        {/* Skeleton for SummarizedComplaintsList */}
        <ComplaintItemSkeleton />
        <ComplaintItemSkeleton />
        <ComplaintItemSkeleton />
      </Flex>
    </Wrapper>
  );
}
